import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { forkJoin, Observable, Subject, takeUntil } from 'rxjs';
import { DocumentoAllegatoAdapter } from 'src/app/common/components/documenti/documento-update-metadati/documento-allegato-adapter';
import { FormFieldBase } from 'src/app/common/components/dynamic-form-field/components/dynamic-form-light/models/form-field-base';
import { MetadatoDocumento, questionsBasic } from 'src/app/common/form/documento/document-uploaded/campi';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { DataInput } from 'src/app/common/models/dto/data-input';
import { UpdateMetadatiDocumentoRequest } from 'src/app/common/models/dto/update-metadati-documento-request';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { Provenienza } from 'src/app/common/models/tipologiche/provenienza';
import { TipoDocumento } from 'src/app/common/models/tipologiche/tipo-documento';
import { TipoTipologica } from 'src/app/common/models/tipologiche/tipo-tipologica';
import { VisibilitaDocumento } from 'src/app/common/models/tipologiche/visibilita-documento';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { mapToBoolean, mapToTipoTipologica } from './utils-remap';
import { DetailTableComponent } from 'src/app/common/form/documento/document-uploaded/detail-table/detail-table.component';
import { MetadatoDocumentoFormComponent } from './metadato-documento-form/metadato-documento-form.component';

@Component({
  selector: 'app-update-metadati',
  templateUrl: './update-metadati.component.html',
  styleUrls: ['./update-metadati.component.css']
})
export class UpdateMetadatiComponent implements OnInit, OnDestroy {
  data: DocumentoAllegatoAdapter;
  documento: DocumentoAllegato;
  modificaDocumentoForm: FormGroup;
  tipiProvenienza: Provenienza[];
  tipiDocumento: TipoDocumento[];
  isCensimentoDocumenti: boolean = false;
  tipiVisibilitaDocumento: VisibilitaDocumento[];
  documentiScansionati:any = [];
  documentiScansionatiTemp:any = [];
  fascicolo: FascicoloFull;
  tipoPratica: any;
  metadataDocumento: MetadatoDocumento = null;
  isProtocol = false;
  readonlyMode = false;
  @ViewChild('metadatoDocumentoForm')metadatoDocumentoFormComponent: MetadatoDocumentoFormComponent; 

  private destroy$ = new Subject<void>();
  constructor(
    private dialogConfig: DialogConfig,
    private helpers: HelpersService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private operationService: OperationsService,
    private dialogRef: DialogRef
  ) {

  }
  ngOnInit(): void {
    let copyDoc = JSON.stringify(this.dialogConfig.data.documento);
    this.documento = JSON.parse(copyDoc)
    this.isProtocol = !!this.documento.numeroProtocollo;
    this.metadataDocumento = this.documento.metadatoDocumento;
    this.fascicolo = this.dialogConfig.data.fascicolo;
    this.tipoPratica = this.dialogConfig.data.tipoPratica;
    this.data = new DocumentoAllegatoAdapter(this.documento);
    this.configurationsRequests();
  }

  createForm() {
    this.modificaDocumentoForm = this.fb.group({
      titolo: [this.data.documento.titolo, Validators.required],
      note: [this.data.documento.note],
      tipoDocumento: [this.data.documento.tipoDocumento, Validators.required],
      provenienza: [this.data.documento.provenienza, Validators.required],
      dataRiferimento: [this.data.documento.dataRiferimento, Validators.required],
      oggettoProtocolloEsteso: [this.data.documento.oggettoProtocolloEsteso],
      tipoVisibilitaDocumento: [this.data.documento.tipoVisibilitaDocumento, Validators.required],
      estremiProvvedimento: [this.data.documento.estremiProvvedimento],
      dataAnnullamento: [this.data.documento.dataAnnullamento],
      // detail: this.fb.array(this.documentiScansionati)
    });
    this.checkStatoDocumento();
    if (this.isDocumentoInConservazione()) {
      this.readonlyMode = true;
      this.disableCampiNonModificabili();
    }
  }

  resetForm() {
    this.modificaDocumentoForm.reset({
      titolo: this.documento.titolo,
      note: this.documento.note,
      tipoDocumento: this.documento.tipoDocumento,
      provenienza: this.documento.provenienza,
      dataRiferimento: this.documento.dataRiferimento,
      oggettoProtocolloEsteso: this.documento.oggettoProtocolloEsteso,
      tipoVisibilitaDocumento: this.documento.tipoVisibilitaDocumento,
      estremiProvvedimento: this.documento.estremiProvvedimento,
      dataAnnullamento: this.documento.dataAnnullamento
    });

    this.checkStatoDocumento();
    this.metadataDocumento = JSON.parse(
      JSON.stringify(this.documento.metadatoDocumento)
    );
    this.metadatoDocumentoFormComponent?.resetForm();
    if (this.readonlyMode) {
      this.disableCampiNonModificabili();
    }
  }


  checkStatoDocumento() {
    if (this.data.documento.statoDocumento === 'ANNULLATO' && this.data?.documento?.flagAllegatoPrincipale){
      this.modificaDocumentoForm.get('estremiProvvedimento').setValidators([Validators.required]);
      this.modificaDocumentoForm.get('dataAnnullamento').setValidators([Validators.required]);
    } else {
      this.modificaDocumentoForm.get('estremiProvvedimento').clearValidators();
      this.modificaDocumentoForm.get('dataAnnullamento').clearValidators();
    }
    this.modificaDocumentoForm.get('estremiProvvedimento').updateValueAndValidity();
    this.modificaDocumentoForm.get('dataAnnullamento').updateValueAndValidity();
  }

  configurationsRequests() {
    let provenienza$: Observable<any> = this.helpers.getTipiProvenienzaDocumento();
    let tipiDocumento$: Observable<any> = this.helpers.getTipiDocumenti();
    let visibilita$: Observable<any> = this.helpers.getTipiVisibilitaDocumento();
    forkJoin({
      provenienza: provenienza$,
      tipiDocumento: tipiDocumento$,
      visibilita: visibilita$
    })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: ({ provenienza, tipiDocumento, visibilita }) => {
        this.tipiProvenienza = provenienza;
        this.tipiDocumento = tipiDocumento && tipiDocumento.length > 0 
          ? (tipiDocumento.sort((a, b)=>(a.label < b.label ) ? -1 : 1)) 
          : [];
        this.tipiVisibilitaDocumento = visibilita;
        this.createForm();
        this.cdr.detectChanges();
      },
      error: err => {
        console.error('Errore nella chiamata', err);
      }
    });
  }

  update() {
    this.saveOperation();
  }

  disableCampiNonModificabili(): void {
    Object.keys(this.modificaDocumentoForm.controls).forEach(key => {
      if (!['note', 'oggettoProtocolloEsteso'].includes(key)) {
        this.modificaDocumentoForm.controls[key].disable();
      }
    });
  }

  saveOperation() {
    let payload = {...this.data};
    let request: UpdateMetadatiDocumentoRequest = new UpdateMetadatiDocumentoRequest();
    request.documento = {...payload.documento};
    if ('primary' in request.documento) {
      delete (request.documento as any).primary;    
    }
    request.documento.metadatoDocumento = this.metadataDocumento;
    request.dataInput = new DataInput(
      this.fascicolo.praticaBase.id, 
      this.fascicolo.id, 
      this.fascicolo.praticaBase.intestazione.campi.posizionePratica, 
      this.fascicolo.posizione, 
      this.tipoPratica
    );

    console.log(request, 'REQUEST')
    this.operationService.updateMetadatiDocumento(request).subscribe(response => {
      this.dialogRef.close({response: response});
    });
  }

  getNameFile(nameFile) {
    return nameFile.split("/").slice(-1)[0];
  }

  onFormMetadataChanges(event: MetadatoDocumento) {
    let remap = event;
    if("documentoUnico" in remap) {
      remap.documentoUnico = mapToBoolean(event.documentoUnico);
    }
    remap.modalitaFormazioneDocumento = mapToTipoTipologica(event.modalitaFormazioneDocumento);
    remap.motivoAssenzaFirma = mapToTipoTipologica(event.motivoAssenzaFirma);
    remap.tipoUfficioProduttore = mapToTipoTipologica(event.tipoUfficioProduttore);
    this.metadataDocumento = event;
  }

  isDocumentoInConservazione(): boolean {
    const stato = this.data?.documento?.statoConservazione;
    return stato != null &&
      ['INVIATO', 'CONSERVAZIONE_MANUALE', 'CONSERVATO'].includes(stato);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
